import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from 'src/app/Pipes/safe.pipe';
import { LanguageListPipe } from 'src/app/Pipes/language-list.pipe';


@NgModule({
  declarations: [SafePipe, LanguageListPipe],
  imports: [
    CommonModule
  ],
  exports:[SafePipe, LanguageListPipe],
})
export class SharedModule { 

}
